import React from 'react'
import PropTypes from 'prop-types'
import {
  RegulatoryNewsMain,
  IframeContainer
} from './index.style'
import Spacer from '@components/Spacer'

const RegulatoryNews = () => {

  const firstIframeUrl = 'https://sirius.brighterir.com/public/brave_bison/news_alerts/rns_email_alerts/register';

  return (
    <RegulatoryNewsMain>
      <IframeContainer>
        <iframe width="100%" height="800px" frameBorder="0" src={firstIframeUrl}
          loading="lazy"></iframe>
      </IframeContainer>
      <Spacer size={[40, 80]} />
    </RegulatoryNewsMain>
  )
}

export default RegulatoryNews
